import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from './FormManager';
import './Pricing.css';

import { Helmet } from 'react-helmet';

const Pricing = () => {
  const { t } = useTranslation();
  const { openGeneralForm } = useForm();
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const pricingCardRef = useRef(null);
  
  // Animation on scroll
  useEffect(() => {
    const section = sectionRef.current;
    const title = titleRef.current;
    const description = descriptionRef.current;
    const pricingCard = pricingCardRef.current;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          section.classList.add('visible');
          setTimeout(() => title.classList.add('visible'), 200);
          setTimeout(() => description.classList.add('visible'), 400);
          setTimeout(() => pricingCard.classList.add('visible'), 600);
          
          // Animate features with staggered delay
          const features = pricingCard.querySelectorAll('.pricing-feature');
          features.forEach((feature, index) => {
            setTimeout(() => feature.classList.add('visible'), 700 + (index * 100));
          });
          
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    
    if (section) {
      observer.observe(section);
    }
    
    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <>
      

      <section className="pricing" ref={sectionRef}>
      <div className="pricing-background">
        <div className="pricing-shape pricing-shape-1"></div>
        <div className="pricing-shape pricing-shape-2"></div>
      </div>
      
      <div className="container">
        <div className="pricing-content">
          <h2 className="pricing-title" ref={titleRef}>
            {t('pricingTitle')}
          </h2>
          
          <p className="pricing-description" ref={descriptionRef}>
            {t('pricingDescription')}
          </p>
          
          <div className="pricing-card" ref={pricingCardRef}>
              <div className="pricing-card-header">
                <div className="original-price">€3000</div>
                <div className="pricing-amount">
                  <div className="pricing-price">
                    <div className="pricing-main">
                      <span className="pricing-currency">€</span>
                      <span className="pricing-number">997</span>
                      <span className="pricing-period">/{t('pricingPeriod')}</span>
                    </div>
                    <div className="pricing-breakdown">
                      <span className="breakdown-item">
                        <span className="breakdown-plus">+</span>
                        <span className="breakdown-amount">€500</span>
                        <span className="breakdown-label">{t('pricinglabel')}</span>
                      </span>
                    </div>
                  </div>
                </div>
            </div>
            
            <div className="pricing-features">
              <div className="pricing-feature">
                <div className="feature-icon">✓</div>
                <div className="feature-text">{t('pricingFeature1')}</div>
              </div>
              
              <div className="pricing-feature">
                <div className="feature-icon">✓</div>
                <div className="feature-text">{t('pricingFeature2')}</div>
              </div>
              
              <div className="pricing-feature">
                <div className="feature-icon">✓</div>
                <div className="feature-text">{t('pricingFeature3')}</div>
              </div>
              
              <div className="pricing-feature">
                <div className="feature-icon">✓</div>
                <div className="feature-text">{t('pricingFeature4')}</div>
              </div>
              
              <div className="pricing-feature">
                <div className="feature-icon">✓</div>
                <div className="feature-text">{t('pricingFeature5')}</div>
              </div>
              
              <div className="pricing-feature">
                <div className="feature-icon">✓</div>
                <div className="feature-text">{t('pricingFeature6')}</div>
              </div>
              
              <div className="pricing-feature">
                <div className="feature-icon">✓</div>
                <div className="feature-text">{t('pricingFeature7')}</div>
              </div>
              
              <div className="pricing-feature">
                <div className="feature-icon">✓</div>
                <div className="feature-text">{t('pricingFeature8')}</div>
              </div>
            </div>
            
            <div className="pricing-cta">
              <button className="pricing-button" onClick={openGeneralForm}>{t('pricingCta')}</button>
              <p className="cta-note">{t('ctaNote')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default Pricing;
